import Layout from '../components/common/Layout';
import PageContainer from '../components/common/PageContainer';
import InvoiceScreen from '../components/screens/invoices/InvoiceScreen';

export default function Invoice(props) {
  return (
    <Layout headerTitle="Invoices">
      <PageContainer id="invoice">
        <InvoiceScreen props={props} />
      </PageContainer>
    </Layout>
  );
}
